import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useMe, useTeam } from '../hooks';
import { startWriteSpan } from './startWriteSpan';

/**
 * Returns a function that starts the span of a write that does not go through
 * `useApiMutation`, such as a form that calls the API client directly. Call
 * the function it returns when the write has settled.
 */
export function useStartWriteSpan() {
  const queryClient = useQueryClient();
  const [{ id: teamId }] = useTeam();
  const { type: userType } = useMe();

  return useCallback(
    (action: string) =>
      startWriteSpan({
        action,
        attributes: {
          'team.id': teamId,
          portal: userType === 'owner' ? 'owner' : 'pm',
        },
        queryClient,
      }),
    [queryClient, teamId, userType]
  );
}
